import React from "react";

const summaryStyle: React.CSSProperties = {
  marginBottom: 8,
  fontSize: 12,
  color: "rgba(0, 0, 0, 0.65)",
};

interface StatItem {
  label: string;
  value: string | number;
}

interface AgentContainerTableSummaryProps {
  items: StatItem[];
}

export const AgentContainerTableSummary: React.FC<
  AgentContainerTableSummaryProps
> = ({ items }) => (
  <div style={summaryStyle}>
    {items.map((item, index) => (
      <React.Fragment key={item.label}>
        {index > 0 ? " · " : null}
        <strong>{item.value}</strong> {item.label}
      </React.Fragment>
    ))}
  </div>
);
